import { Redirect } from 'react-router-dom';
import { compose, branch, withProps, renderComponent } from 'react-recompose';

import withReduxConnect from './withReduxConnect';
import { isAuthenticated } from '~/state/ducks/auth/selectors';


const RedirectToLogin = withProps({ to: '/login' })(Redirect);

export default compose(
    withReduxConnect({
        mapStateToProps: state => ({
            isAuthenticated: isAuthenticated(state),
        }),
    }),
    branch(({ isAuthenticated }) => !isAuthenticated, renderComponent(RedirectToLogin)),
);
